<app-title-section></app-title-section>


<div class="card " style="margin-left: 15px; margin-bottom: 15px; margin-right: 15px;min-height:86vh">
    <!-- Tabs -->
    <ul class=" nav nav-tabs m-0" style=" border-bottom: 1px solid #eee; padding-top: 24px">
        <li class="nav-item">
            <a
                    class="nav-link"
                    routerLink="actif"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    href="javascript:void(0)"
            >
                Actif ({{ actifCount }})
            </a>
        </li>
        <li class="nav-item">
            <a
                    class="nav-link"
                    routerLink="archive"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    href="javascript:void(0)"
            >
                Archivé ({{ archivedCount }})
            </a>
        </li>

    </ul>

    <!-- Child Component Will Render Here -->
    <router-outlet></router-outlet>
</div>


<!-- Hidden File Input -->
<input #fileInput type="file" class="form-control d-none" (change)="onFileSelected($event)" accept=".xlsx" />

<!-- Import Modal -->
<ng-template #importModal let-modal>
    <div class="modal-header products-import-modal__header">
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Fermer">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body products-import-modal__body" style="padding-left: 174px;padding-right: 174px">
        <div class="products-import-modal__content">
            <h3 class="products-import-modal__title">Importer fichier</h3>
            <p class="products-import-modal__subtitle">Ajoutez un fichier depuis votre appareil.</p>

            <div class="products-import-modal__step d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                    <button type="button" class="number-button" disabled tabindex="-1">1</button>
                    <p class="products-import-modal__step-label mb-0">Télécharger un fichier vide</p>
                </div>
                <button
                    type="button"
                    class="btn btn-primary btn-sm d-flex align-items-center justify-content-center products-import-modal__download-btn"
                    (click)="downloadTemplate()"
                    title="Télécharger le modèle"
                    aria-label="Télécharger le modèle"
                >
                    <i data-feather="download" class="feather-icon"></i>
                </button>
            </div>

            <div class="products-import-modal__step d-flex align-items-center">
                <button type="button" class="number-button" disabled tabindex="-1">2</button>
                <p class="products-import-modal__step-label mb-0">Validez ou cliquez pour télécharger</p>
            </div>



            <div class="step-form products-import-modal__drop-zone">
                <div
                    class="form-section rounded border-style gap-3 products-import-modal__drop"
                    (click)="triggerFileInput($event)"
                    [ngClass]="{ 'success-bg': selectedFile }"
                >
                    <span class="action-icon products-import-modal__file-icon" [class.text-success]="selectedFile">
                        <span data-feather="file"></span>
                    </span>
                    <div *ngIf="selectedFile" class="file-name">{{ selectedFile.name }}</div>
                    <h5 *ngIf="!selectedFile" class="products-import-modal__drop-title">Veuillez valider votre fichier avant de l'importer</h5>
                    <h5 *ngIf="selectedFile" class="products-import-modal__drop-title">Importation prête !</h5>
                    <p *ngIf="selectedFile" class="mb-0 products-import-modal__drop-hint">
                        Vous pouvez désormais importer {{ selectedFile.name }}.
                    </p>
                    <p *ngIf="!selectedFile" class="products-import-modal__drop-hint mb-0">
                        La taille maximale du fichier est de 1 Mo, seuls les fichiers .xlsx sont autorisés.
                    </p>
                    <span class="action-icon products-import-modal__status-icon" [class.text-primary]="!selectedFile" [class.text-success]="selectedFile">
                        <span *ngIf="!selectedFile" data-feather="download"></span>
                        <span *ngIf="selectedFile" data-feather="check" class="large-icon"></span>
                    </span>
                </div>
            </div>
            <div class="products-import-modal__step d-flex align-items-center">
                <button type="button" class="number-button" disabled tabindex="-1">3</button>
                <p class="products-import-modal__step-label mb-0">Commencez le processus</p>
            </div>
        </div>
    </div>
    <div class="products-import-modal__footer d-flex align-items-center justify-content-center">
        <button type="button" class="btn" (click)="modal.dismiss('Cancel click')" style="background: rgba(128, 131, 144, 0.16);color: rgba(128, 131, 144, 1)">Annuler</button>
        <button type="button" class="btn btn-primary" (click)="importFile(modal)" [disabled]="!selectedFile">Importer</button>
    </div>
</ng-template>
